// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard_dashboard__2X4pa {
  width: 100%;
  height: 100%;
  color: #212121; }

.dashboard_wrapper__0tDyO {
  width: 100%;
  height: calc(100vh - 130px);
  overflow: hidden; }

.dashboard_whiteBackground__ULlNI {
  background-color: white; }

.dashboard_tabs__Pq4j1 {
  position: relative;
  display: flex;
  gap: 20px; }

.dashboard_tab__O\\+tiW {
  padding: 15px 8px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  text-decoration: none;
  transition: all 0.4s; }
  .dashboard_tab__O\\+tiW span {
    transition: all 0.4s; }

.dashboard_active__aha0\\+ {
  color: #fe6100;
  border-bottom: 3px solid #FE6100; }

.dashboard_noActive__bM5oF {
  color: #212121;
  border-bottom: 3px solid #FFFFFF; }
  .dashboard_noActive__bM5oF:active span {
    color: #b62f00; }
  .dashboard_noActive__bM5oF:hover {
    background: rgba(254, 97, 0, 0.1);
    border-bottom: 3px solid rgba(254, 97, 0, 0.1); }
    .dashboard_noActive__bM5oF:hover span {
      color: #fe6100; }

.dashboard_content__2cIfx {
  width: 100%;
  height: 100%;
  padding-top: 20px; }

.dashboard_error__wF1ed {
  color: #ff0000;
  font-size: 24px; }

.dashboard_noreports__FTR\\+W {
  padding: 10px 14px;
  background: #e0e0e0;
  border-radius: 13px;
  text-align: center;
  color: #666666;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  margin-top: 20px; }

.dashboard_scale__AKwBL {
  position: absolute;
  bottom: 20px;
  right: 20px; }
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/dashboard.module.scss"],"names":[],"mappings":"AAGA;EACE,WAAW;EACX,YAAY;EACZ,cAAc,EAAA;;AAEhB;EACE,WAAW;EACX,2BAA2B;EAC3B,gBAAgB,EAAA;;AAGlB;EACE,uBAAuB,EAAA;;AAEzB;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS,EAAA;;AAGX;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB,EAAA;EAPtB;IASI,oBAAoB,EAAA;;AAGxB;EACE,cAAc;EACd,gCAAgC,EAAA;;AAElC;EACE,cAAc;EACd,gCAAgC,EAAA;EAFlC;IAKM,cAAc,EAAA;EALpB;IASI,iCAAiC;IACjC,8CAA8C,EAAA;IAVlD;MAYM,cAAc,EAAA;;AAIpB;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB,EAAA;;AAGnB;EACE,cAAc;EACd,eAAe,EAAA;;AAEjB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB,EAAA;;AAGlB;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW,EAAA","sourcesContent":["@import '../../styles/media.scss';\n@import '../../styles/fonts.scss';\n\n.dashboard {\n  width: 100%;\n  height: 100%;\n  color: #212121;\n}\n.wrapper {\n  width: 100%;\n  height: calc(100vh - 130px);\n  overflow: hidden;\n \n}\n.whiteBackground {\n  background-color: white;\n}\n.tabs {\n  position: relative;\n  display: flex;\n  gap: 20px;\n}\n\n.tab {\n  padding: 15px 8px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n  text-decoration: none;\n  transition: all 0.4s;\n  span{\n    transition: all 0.4s;\n  }\n}\n.active {\n  color: #fe6100;\n  border-bottom: 3px solid #FE6100;\n}\n.noActive {\n  color: #212121;\n  border-bottom: 3px solid #FFFFFF;\n  &:active {\n    span {\n      color: #b62f00;\n    }\n  }\n  &:hover {\n    background: rgba(254, 97, 0, 0.1);\n    border-bottom: 3px solid rgba(254, 97, 0, 0.1);\n    span {\n      color: #fe6100;\n    }\n  }\n}\n.content {\n  width: 100%;\n  height: 100%;\n  padding-top: 20px;\n}\n\n.error {\n  color: #ff0000;\n  font-size: 24px;\n}\n.noreports {\n  padding: 10px 14px;\n  background: #e0e0e0;\n  border-radius: 13px;\n  text-align: center;\n  color: #666666;\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  margin-top: 20px;\n}\n\n.scale {\n  position: absolute;\n  bottom: 20px;\n  right: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `dashboard_dashboard__2X4pa`,
	"wrapper": `dashboard_wrapper__0tDyO`,
	"whiteBackground": `dashboard_whiteBackground__ULlNI`,
	"tabs": `dashboard_tabs__Pq4j1`,
	"tab": `dashboard_tab__O+tiW`,
	"active": `dashboard_active__aha0+`,
	"noActive": `dashboard_noActive__bM5oF`,
	"content": `dashboard_content__2cIfx`,
	"error": `dashboard_error__wF1ed`,
	"noreports": `dashboard_noreports__FTR+W`,
	"scale": `dashboard_scale__AKwBL`
};
export default ___CSS_LOADER_EXPORT___;
